__turbopack_context__.v({
  "backgroundImage": "TrendingProducts-module-scss-module__KjkgYa__backgroundImage",
  "backgroundImageWrapper": "TrendingProducts-module-scss-module__KjkgYa__backgroundImageWrapper",
  "backgroundOverlay": "TrendingProducts-module-scss-module__KjkgYa__backgroundOverlay",
  "bgPositionCenter": "TrendingProducts-module-scss-module__KjkgYa__bgPositionCenter",
  "bgPositionLeft": "TrendingProducts-module-scss-module__KjkgYa__bgPositionLeft",
  "bgPositionRight": "TrendingProducts-module-scss-module__KjkgYa__bgPositionRight",
  "centered": "TrendingProducts-module-scss-module__KjkgYa__centered",
  "container": "TrendingProducts-module-scss-module__KjkgYa__container",
  "ctaWrapper": "TrendingProducts-module-scss-module__KjkgYa__ctaWrapper",
  "grid": "TrendingProducts-module-scss-module__KjkgYa__grid",
  "heading": "TrendingProducts-module-scss-module__KjkgYa__heading",
  "headingAccent": "TrendingProducts-module-scss-module__KjkgYa__headingAccent",
  "productCard": "TrendingProducts-module-scss-module__KjkgYa__productCard",
  "section": "TrendingProducts-module-scss-module__KjkgYa__section",
  "sectionWithBackground": "TrendingProducts-module-scss-module__KjkgYa__sectionWithBackground",
  "sliderWrapper": "TrendingProducts-module-scss-module__KjkgYa__sliderWrapper",
  "swiper": "TrendingProducts-module-scss-module__KjkgYa__swiper",
  "swiperCentered": "TrendingProducts-module-scss-module__KjkgYa__swiperCentered",
});
